import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

type FileManagerEmptyStateProps = {
  onUpload?: () => void;
};

const FileManagerEmptyState = ({ onUpload }: FileManagerEmptyStateProps) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ textAlign: 'center', p: 5 }}>
      <Typography>{t('system.fileManager.noFilesFound')}</Typography>
      {onUpload ? (
        <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
          {t('system.fileManager.tryUploading')}{' '}
          <Button variant="text" size="small" onClick={onUpload}>
            {t('system.fileManager.uploadNewFile')}
          </Button>
          .
        </Typography>
      ) : null}
    </Box>
  );
};

export default FileManagerEmptyState;
